import { LoadingSpan, Page } from '@uturn/portal/components';
import { Suspense } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { InvoicesTable } from '../components/table';

export function InvoicesOverview() {
	const { t } = useTranslation();

	return (
		<>
			<Helmet title={t('pages.invoices.title', 'Invoices').toString()} />
			<Page title={t('pages.invoices.title', 'Invoices').toString()}>
				<Suspense fallback={<LoadingSpan />}>
					<InvoicesTable />
				</Suspense>
			</Page>
		</>
	);
}
